"use client";

import { useLoading } from '../contexts/LoadingContext';
import { usePathname } from 'next/navigation';
import BrailleSpinner from './BrailleSpinner';

export default function GlobalLoading() {
  const { isLoading, loadingMessage } = useLoading();
  const pathname = usePathname();

  // /heatmap and /playbooktest both render their own custom in-page
  // spinners that integrate with their visualization state machines —
  // letting the global overlay appear on top of them would double-spin.
  // /portfolios renders its own grey shimmer skeleton (PortfolioDashboard
  // loading state) that mirrors the performance table, so the full-screen
  // overlay is skipped there too — otherwise it would cover the skeleton
  // and defeat the smooth fade-in.
  const isPortfolios = pathname === '/portfolios' || pathname.startsWith('/portfolios/');
  // /watchlist renders its own in-page BrailleSpinner (WatchlistManager) — the
  // full-screen overlay would just double up on top of it.
  const isWatchlist = pathname === '/watchlist';
  if (!isLoading || pathname === '/heatmap' || pathname === '/playbooktest' || isPortfolios || isWatchlist) return null;

  return (
    <div className="fixed inset-0 bg-[#1a1a1a]/90 backdrop-blur-md z-40 flex items-center justify-center" style={{ top: '48px' }}>
      <div style={{ padding: '48px 16px' }}>
        <BrailleSpinner label={loadingMessage || 'Loading data…'} />
      </div>
    </div>
  );
}
